<template>
    <div>
        <the-document-banner></the-document-banner>
        <the-document-entries></the-document-entries>
    </div>
</template>

<script>
import TheDocumentBanner from '../components/the-document-banner';
import TheDocumentEntries from './components/the-document-entries';

export default {
    name: 'Home',
    components: { TheDocumentEntries, TheDocumentBanner }
};
</script>

<style lang="scss" scoped></style>
